import searchActions from './search';
import selectActions from './select';

export default {
  ...searchActions,
  ...selectActions
};
